import storeConfig from 'Stores/shopify-generic/config.js';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
}
